import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { INodeWithPath } from "../../../../interface/interfaces";

interface IInitialState {
    allNodes: INodeWithPath[]
}

const initialState: IInitialState = {
    allNodes: []
}

const AllNodesSlice = createSlice({
    name:'AllNodes',
    initialState,
    reducers: {
        getAllNodes: (state: IInitialState, action: PayloadAction<INodeWithPath[]>)=>{
            state.allNodes = action.payload;
        },
        clearAllNodes: (state:IInitialState)=>{
            state.allNodes = []
        }
    }
})

export default AllNodesSlice.reducer;
export const {getAllNodes, clearAllNodes} = AllNodesSlice.actions;